// ABOUTME: Shared stat/quick-access card components used by the Activity Dashboard and reused elsewhere for the same visual language
import React from 'react';
import { Box, Card, CardContent, Paper, Typography, CircularProgress } from '@mui/material';

export const StatCard = ({ title, value, icon: Icon, color, loading, description, onClick, clickable = false, selected = false }) => (
    <Card
        elevation={2}
        sx={{
            height: '100%',
            minHeight: 100,
            borderRadius: 4,
            cursor: clickable ? 'pointer' : 'default',
            transition: 'all 0.2s ease-in-out',
            borderBottom: '3px solid',
            borderBottomColor: selected ? 'primary.main' : 'transparent',
            '&:hover': clickable ? {
                boxShadow: 4,
                backgroundColor: 'action.hover',
            } : {},
        }}
        onClick={clickable ? onClick : undefined}
    >
        <CardContent sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                {title}
            </Typography>
            <Box display="flex" alignItems="center" gap={1.5}>
                <Icon sx={{ color: color || 'primary.main', fontSize: 28, flexShrink: 0 }} />
                {loading ? (
                    <CircularProgress size={24} />
                ) : (
                    <Typography variant="h5" component="span" fontWeight={600}>
                        {value}
                    </Typography>
                )}
            </Box>
            {description && (
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                    {description}
                </Typography>
            )}
        </CardContent>
    </Card>
);

// Quick Access card: single structure, no duplicate text, fixed min height, clickable
export const QuickAccessCard = ({ title, description, icon: Icon, color, path, onClick }) => (
    <Paper
        elevation={2}
        sx={{
            height: '100%',
            minHeight: 120,
            p: 2,
            borderRadius: 4,
            display: 'flex',
            flexDirection: 'column',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                boxShadow: 4,
                backgroundColor: 'action.hover',
            },
        }}
        onClick={() => onClick(path)}
    >
        <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1 }}>
            <Icon sx={{ color: color || 'primary.main', fontSize: 22 }} />
            <Typography variant="subtitle1" fontWeight={600}>{title}</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
            {description}
        </Typography>
    </Paper>
);
